//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";
import { afterNextRender } from "@polymer/polymer/lib/utils/render-status.js";

import "../../../components/desktop/webinar-detail/BannerProduct/BannerProduct";
import "../../../components/desktop/webinar-detail/ModalFAQ/ModalFAQ";
import "../../../components/desktop/shared/ModalShare";
import "../../../components/desktop/shared/ToastNotification";
import "../../../components/desktop/shared/LiveChatBox";
import "../../../components/desktop/webinar/VideoPlayer/VideoPlayer";
import "../../../3rdparty/socket-io/socket-io";
import Alodokter from "../../../utils/Alodokter";
import General from "../../../utils/General";
import WebinarAnalytics from "../../../analytics/WebinarAnalytics";
import "../../../components/desktop/shared/GeneralToast";

import { 
  _sponsoreChannelLogo,
  _sponsoreChannelCategory,
  _sponsoreChannelName,
  _isShowSponsoreChannel,
  _isShowGreenCard,
  _isShowRegisterButton,
  _isShowPaidWebinarButton,
  _isStrikethroughPrice,
  _formattedAddSpace,
  _checkShowVideo,
  _checkStartPosttestSingle,
  _checkCertificateSingle,
  _webinarStatus,
  _checkIconPlayShow,
  _webinarEventStatus
} from "../../../utils/WebinarDetail";

import { _checkSkpPoint } from "../../../utils/skp";

import iconPlusWhite from "../../../images/icons/icon_plus_white.svg";
import iconCalenderGrey from "../../../images/icons/icon_calender_grey.svg";
import iconShareBlue from "../../../images/icons/icon_share_blue.svg";
import iconSkp from "../../../images/icons/icon_badge_skp.svg";
import iconAp from "../../../images/icons/icon_poin_ap.svg";
import iconChecklistBlack from "../../../images/icons/icon_circlechecklist_black.svg";
import VideoPlayerAnalytics from "../../../analytics/VideoPlayerAnalytics";
import GeneralAnalytics from "../../../analytics/GeneralAnalytics";

class WebinarShow extends PolymerElement {
  static get template() {
    return html`
      <style>
        button {
          font-family: "Lato", sans-serif;
        }
        .mt-1 {
          margin-top: 10px !important;
        }
        .text-display1 {
          font-size: 24px;
          font-weight: 700;
          color: #424242;
          line-height: 32px;
          margin: 0 !important;
          padding: 0 !important;
        }
        .text-display2 {
          font-size: 18px;
          margin: 0 !important;
          padding: 0 !important;
        }
        .container {
          display: flex !important;
          flex-direction: column !important;
          margin: 0 auto;
          padding: 26px 2px 60px;
        }
        .row {
          margin-bottom: 5px;
        }

        .conatiner-main {
          display: flex !important;
          align-items: flex-start;
        }
        .content-main-left {
          flex: 2;
        }
        .content-main-right {
          flex: 1;
          margin-left: 20px;
        }
        .card-menu {
          display: flex !important;
          flex-direction: column !important;
          border: 1px solid #DADEE4;
          padding: 16px;
        }
        .btn {
            align-items: center;
            justify-content: center;
        }
        .btn-success {
          line-height: 44px;
          border: 1px solid #ED6700;
          border-radius: 5px;
          text-align: center;
          display: flex;
          background-color: #ED6700;
          font-size: 18px;
          color: white;
          cursor: pointer;
        }
        .btn-primary {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #FFFFFF;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 12px 16px;
          gap: 4px;
          background: #3570D2;
          border-radius: 8px;
          cursor: pointer;
        }
        .green-card-with-checkmark {
          display: flex;
          align-items: flex-start;
          text-align: left;
          border: 1px solid #007C41;
          border-radius: 5px;
          background-color: #D2FFEA;
          color: #424242;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          padding: 12px;
        }
        .btn-outline-primary {
          line-height: 44px;
          border: 1px solid #3570D2;
          background-color: white;
          border-radius: 5px;
          text-align: center;
          display: flex;
          font-size: 18px;
          color: #3570D2;
          cursor: pointer;
        }

        .btn-noborder-primary {
          line-height: 44px;
          background-color: white;
          border-radius: 5px;
          border-style: none;
          text-align: center;
          display: block;
          font-size: 18px;
          color: #3570D2;
          cursor: pointer;
        }

        .card-info {
          display: flex !important;
          flex-direction: column !important;
          border: 1px solid #3570D2;
          padding: 16px;
          background-color: #E5EFFF
        }

        .content-main-left .content-text {
          margin-top: 12px;
          margin-bottom: 60px !important;
        }
        .text-description {
          margin-top: 8px;
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 135%;
        }
        .content-column {
            display: flex !important;
            flex-direction: row !important;
            align-items: center !important;
        }
        .content-column label {
          display: flex !important;
          align-items: center !important;
        }
        .content-text p {
          line-height: 24px;
          margin: 8px 0px 18px 0px;
          color: #424242;
        }
        .content-text p p a {
          overflow-wrap: anywhere;
        }
        .sponsore-channel-container {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #ECECEC;
          padding-bottom: 16px;
          margin-top: 16px;
        }
        .sponsore-channel-container img {
            width: 32px;
            height: 32px;
            border: 1px solid #D9D9D9;
            border-radius: 50%;
            margin-right: 8px;
            object-fit: contain;
        }
        .sponsore-channel-container p {
            margin: 0px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2; /* number of lines to show */
            -webkit-box-orient: vertical;
        }
        .sponsore-channel-title {
            display: inline-block;
        }
        .sponsore-category {
          color: #7F7F7F;
          font-weight: 600;
          font-size: 14px;
          line-height: 135%;
        }
        .sponsore-name {
          color: #424242;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
        }
      </style>
      <iron-ajax
          id="_registerBtn"
          method="POST"
          url = "/api/general/webinars/register"
          handle-as="json"
          on-response="_handleRegisterResponse"
          debounce-duration="300">
      </iron-ajax>
      <socket-io id="webinarSocket" auto-connecting auto-forwarding
        url="{{socketUrl}}"
        uid="[[userUid]]"
        room-id="[[webinar.id]]"
        on-io-q&a="_handleSocketQuestion"
        on-io-status_webinar="_handleStartAndFinsihSocket"
        is-login="[[isLogin]]"
        on-status-disconnect="_handleSocketDisconnection"
        on-status-connect="_handleSocketConnect">
      </socket-io> 
      <div class="container">
        <div class="row">
          <h1 class="text-display1">Webinar Detail</h1>
        </div>
        <div class="conatiner-main">
          <div class="content-main-left">
            <template is="dom-if" if="{{_checkShowVideo(isLogin, webinar)}}">
              <video-player
                url-live="{{webinar.broadcast_url}}" 
                url-recording="{{webinar.video_recording_url}}" 
                url-banner="{{webinar.thumbnail}}" 
                status="{{webinar.broadcast_status}}"
                status-text="{{webinar.broadcast_status_text}}"
                on-player="_handleListenerPlayer"
                on-tracking-progress-recording="_handleTrackingRecording"
                on-tracking-time-live="_handleTrackingLive"
                id="webinar-video-player">
              </video-player>
            </template>
            <template is="dom-if" if="{{!_checkShowVideo(isLogin, webinar)}}">
              <banner-product
                webinar-status-text="[[webinar.broadcast_status_text]]"
                broadcast-status="[[webinar.broadcast_status]]"
                banner-detail="[[webinar.thumbnail]]"
                play-button="[[_checkIconPlayShow(webinar.broadcast_status, isLogin)]]"
              ></banner-product>
            </template>
            <dom-if if="{{_isShowSponsoreChannel(webinar)}}">
              <template>
                <div class="sponsore-channel-container">
                    <img src="[[_sponsoreChannelLogo(webinar)]]">
                    <div class="sponsore-channel-title">
                        <p class="sponsore-category">{{_sponsoreChannelCategory(webinar)}}</p>
                        <p class="sponsore-name">{{_sponsoreChannelName(webinar)}}</p>
                    </div>
                </div>
              </template>
            </dom-if>
            <div class="content-text">
              <h1 class="text-display1" style="font-size: 18px; color: #3570D2">
                [[webinar.broadcast_time]]
              </h1>
              <h1 class="text-description" style="font-size: 24px;">
                [[webinar.title]]
              </h1>
              <h2 class="text-description" style="color: #7F7F7F;">
                {{_formattedAddSpace(webinar.webinar_category)}}
              </h2>
              <div class="content-column">
                <template is="dom-if" if="{{_checkSkpPoint(webinar.skp_point)}}">
                  <label>
                    <img src="[[iconSkp]]" style="margin: 0px 4px 5px 0px" />
                    <h1
                      class="text-display2"
                      style="color: #F5A623; margin-right: 16px!important;"
                    >
                      +[[formattedSkpPoint(webinar.skp_point)]] SKP
                    </h1>
                  </label>
                </template>
                <label>
                  <img src="[[iconAp]]" style="margin: 0px 4px 5px 0px" />
                  <h1 class="text-display2" style="color: #3570D2">
                    +[[webinar.alo_point]] AP
                  </h1>
                </label>
              </div>
              <p inner-h-t-m-l="[[webinar.content]]"></p>
            </div>
          </div>
          <div class="content-main-right">
            <template is="dom-if" if="{{isShowQnABox}}">
              <live-chat-box
                on-tap-send-msg="sendMsgSocket"
                list-chat="[[listChat]]"
                id="qna-box"
                is-connect="{{socketConnect}}"
              >
              </live-chat-box>
            </template>
            <div class="card-menu" style="margin-bottom: 15px;">
              <template is="dom-if" if="{{_isShowPaidWebinarButton(isRegistered, webinar)}}">
                <h3 class="text-display2">Harga Pendaftaran</h3>
                <template is="dom-if" if="{{isLogin}}">
                  <template is="dom-if" if="{{_isStrikethroughPrice(webinar)}}">
                    <h2 class="text-display1" style="color: #ED6700; margin-bottom: 15px!important;">
                      [[webinar.payment_info.normal_price]] <span style="color: #7F7F7F; text-decoration: line-through;">[[webinar.payment_info.base_price]]</span>
                    </h2>
                  </template>
                  <template is="dom-if" if="{{!_isStrikethroughPrice(webinar)}}">
                    <h2 class="text-display1" style="color: #ED6700; margin-bottom: 15px!important;">
                      [[webinar.payment_info.normal_price]]
                    </h2>
                  </template>
                </template>
                <template is="dom-if" if="{{!isLogin}}">
                  <h2 class="text-display1" style="color: #ED6700; margin-bottom: 15px!important;">
                    [[webinar.payment_info.base_price]]
                  </h2>
                </template>
                <button class="btn btn-success" on-click="goToCheckOutPage">
                  <img
                    src="[[iconPlusWhite]]"
                    style="margin-bottom: 2px!important;"
                  />
                  Beli Tiket
                </button>
              </template>
              <dom-if if="{{_isShowRegisterButton(webinar, isRegistered)}}">
                <template>
                  <button class="btn btn-success" on-click="_registerBtnHandler">
                    <img
                      src="[[iconCalenderGrey]]"
                      style="margin-bottom: 2px!important;"
                    />
                    Daftar
                  </button>
                </template>
              </dom-if>
              <dom-if if="{{_isShowGreenCard(webinar, isRegistered)}}">
                <template>
                  <button class="green-card-with-checkmark">
                    <img
                      src="[[iconChecklistBlack]]"
                      style="margin-bottom: 2px!important; margin-right: 7px;"
                    />
                    Anda sudah terdaftar dalam webinar ini.
                  </button>
                </template>
              </dom-if>
              <template is="dom-if" if="[[_checkStartPosttestSingle(isLogin, webinar)]]">
                <div class="btn btn-primary" on-click="_onNavigateSkp">
                  Mulai Tes
                </div>
              </template>
              <template is="dom-if" if="[[_checkCertificateSingle(isLogin, webinar)]]">
                <div class="btn btn-primary" on-click="_onNavigateCertificate">
                  Lihat Sertifikat
                </div>
              </template>
              <button
                class="btn btn-outline-primary mt-1"
                on-click="handleClickShare">
                <img
                  src="[[iconShareBlue]]"
                  style="margin-bottom: 2px!important;"
                />
                Bagikan
              </button>
              <button
                class="btn btn-noborder-primary mt-1"
                on-click="handleClickFAQ">
                FAQ
              </button>
            </div>
          </div>
        </div>
        <modal-faq is-active="{{modalFAQ}}"></modal-faq>
        <modal-share 
          webinar-id="{{webinar.id}}"
          webinar-title="{{webinar.title}}" 
          is-active="{{modalShare}}"
          webinar-type="{{webinarType}}">
        </modal-share>
        <toast-notification 
          id="modalSuccess" 
          title="Kami akan memberi tahu Anda Kembali pada hari acara"
          title-bold="'[[webinar.title]].'"
          is-active="{{modalSuccess}}">
        </toast-notification>
        <general-toast
          body="{{toastBody}}"
          is-active="{{toastRed}}"
          color="red"
        >
        </general-toast>
        <general-toast 
          body="{{toastBody}}"
          is-active="{{toastGreen}}"
          color="green"
        >
        </general-toast>
      </div>
    `;
  }

  static get properties() {
    return {
      iconPlusWhite: {
        type: String,
        value: iconPlusWhite,
      },
      iconCalenderGrey: {
        type: String,
        value: iconCalenderGrey,
      },
      iconShareBlue: {
        type: String,
        value: iconShareBlue,
      },
      iconAp: {
        type: String,
        value: iconAp,
      },
      iconSkp: {
        type: String,
        value: iconSkp,
      },
      iconChecklistBlack: {
        type: String,
        value: iconChecklistBlack,
      },
      webinar: {
        type: Object,
      },
      listChat: {
        type: Array,
        value: [],
        notify: true
      },
      modalFAQ: {
        type: Boolean,
        value: false,
      },
      modalShare: {
        type: Boolean,
        value: false,
      },
      isRegistered: {
        type: Boolean,
        value: false
      },
      modalSuccess: {
        type: Boolean,
        value: false,
      },
      webinarType: {
        type: Function,
        value: () => {
          const urlParams = new URLSearchParams(window.location.search);
          return urlParams.get('type');
        }
      },
      userUid: {
        type: String,
      },
      isVideoError: {
        type: Boolean,
        value: false,
      },
      _sponsoreChannelLogo: {
        type: Function,
        value: () => _sponsoreChannelLogo
      },
      _sponsoreChannelCategory: {
        type: Function,
        value: () => _sponsoreChannelCategory
      },
      _sponsoreChannelName: {
        type: Function,
        value: () => _sponsoreChannelName
      },
      _isShowSponsoreChannel: {
        type: Function,
        value: () => _isShowSponsoreChannel
      },
      _isShowGreenCard: {
        type: Function,
        value: () => _isShowGreenCard
      },
      _isShowRegisterButton: {
        type: Function,
        value: () => _isShowRegisterButton
      },
      _isShowPaidWebinarButton: {
        type: Function,
        value: () => _isShowPaidWebinarButton
      },
      _isStrikethroughPrice: {
        type: Function,
        value: () => _isStrikethroughPrice
      },
      _formattedAddSpace: {
        type: Function,
        value: () => _formattedAddSpace
      },
      _checkShowVideo: {
        type: Function,
        value: () => _checkShowVideo
      },
      _checkStartPosttestSingle: {
        type: Function,
        value: () => _checkStartPosttestSingle
      },
      _checkCertificateSingle: {
        type: Function,
        value: () => _checkCertificateSingle
      },
      _checkIconPlayShow: {
        type: Function,
        value: () => _checkIconPlayShow
      },
      _webinarEventStatus: {
        type: Function,
        value: () => _webinarEventStatus
      },
      _checkSkpPoint: {
        type: Function,
        value: () => _checkSkpPoint
      },
      isLogin: {
        type: Number
      },
      isShowQnABox: {
        type: Boolean,
        value: false
      },
      disclaimerTitle: {
        type: String
      },
      disclaimerBody: {
          type: String
      },
      socketUrl: {
        type: String,
        value: null
      },
      toastGreen: {
        type: Boolean,
        value: false
      },
      toastRed: {
        type: Boolean,
        value: false
      },
      toastBody: {
        type: String,
        value: ""
      },
      socketConnect: {
        type: Boolean,
        value: false
      },
      trackingVdStartGA4: {
        type: Boolean,
        value: true
      },
      formattedSkpPoint: {
        type: Function,
        value: () => General.formattedSkpPoint
      },
    };
  }

  ready() {
    super.ready();
    if(this.isLogin == 1 && General.getCookie("new_alomedika_logged_in") == undefined) {
      window.location.reload();
      this.isLogin = 0;
    }
    this.isRegistered = this.webinar.is_registered
    const self = this;
    this._checkIsShowChatBox()
    
    window.onbeforeunload = function(e) {
      //window tab close, pindah route, close browser dll
      if(self.webinar.broadcast_status == "live" && self.isLogin){
        // if the webinar status is live
        self.shadowRoot.querySelector("#webinarSocket").send("session_log", {uid: self.userUid, type: 'deactive', room_id: self.webinar.id, platform: "dweb"})
      }
    };

    afterNextRender(this, function() {
      this.sendGaWebinarDetailPageView();
      this.sendGA4WebinarViewItem();
    });

    window.addEventListener('online', () => {
      this.toastBody = "Kembali terhubung dengan koneksi internet."
      this.toastRed = false;
      this.toastGreen = true;
    });

    window.addEventListener('offline', () => {
      this.toastBody = "Tidak ada koneksi internet. Periksa koneksi Wi-fi atau data Anda kemudian coba lagi."
      this.toastGreen = false;
      this.toastRed = true
    });
  }

  handleClickFAQ() {
    const video = this.shadowRoot.querySelector("#webinar-video-player");
    if(this.isLogin && video && !this.isVideoError){
      const player = videojs(video.$.webinar_video_player);
      player.pause();
    }
    GeneralAnalytics.faq("webinar", "detail");
    this.modalFAQ = true;
  }

  handleClickShare() {
    const video = this.shadowRoot.querySelector("#webinar-video-player");
    if(this.isLogin && video){
      const player = videojs(video.$.webinar_video_player);
      player.pause();
    }
    this.modalShare = true;
  }

  _registerBtnHandler(e) {
    e.stopPropagation()
    const registerUser = { id: this.webinar.id, user_uid: this.userUid }
    this.$._registerBtn.params = registerUser
    this.$._registerBtn.generateRequest();
    this.sendWebinarFreeRegisterClicked();
    this.sendGA4WebinarAddToCart();
  }

  _handleRegisterResponse(e) {
    const response = e.detail.response;

    if (response.status == 200) {
      this.isRegistered = true
      this.modalSuccess = true;
    } else if (response.status == 500) {
      null
    } else {
      if (!response.isEmailValid) {
        $('#entrance-overlay').css("display", "block");
      }
    }
  }

  goToCheckOutPage() {
    this.sendWebinarPaidRegisterClicked();
    this.sendGA4WebinarAddToCart();
    if (this.isLogin) {
      window.location = `/payment/list/webinar?id=${this.webinar.id}`
    } else {
      $('#entrance-overlay').css("display", "block");
    }
  }

  _handleStartAndFinsihSocket(e, data){
    //reload browser in action bo start or and webinar
    window.location.reload();

    //GA finished webinar
    if(data.status == "finished") {
      this.sendGALiveFinished()
    }
  }

  _handleSocketQuestion(e, data){
    const chatAddition = new Promise(resolve => {
      this.push('listChat', data);
      resolve();
    })

    chatAddition.then(()=> {
      const chatBox = this.shadowRoot.querySelector("#qna-box").$.scrollable_chat_container
      const diff = chatBox.scrollHeight;
      chatBox.scrollTop = diff;
    })
  }

  sendMsgSocket(e) {
    let msg = e.detail.message
    if (!msg.replace(/\s/g, '').length ) return;
    if (!this.socketConnect) {
      this.toastBody = "Maaf, terjadi kesalahan sistem. Mohon tunggu beberapa saat untuk kembali tersambung.";
      this.toastRed = true
      return
    }
    this.shadowRoot.querySelector("#webinarSocket").send("send_message",  {uid: this.userUid, question: msg, room_id: this.webinar.id})
    const webinarType = this.webinar.type == "single" ? "webinar" : "event";
    const webinarPaid = this.is_paid_webinar ? "paid" : "free";
    const userRegisterStatus = this.webinar.is_registered ? "registered" : "not_registered";
    const eventLabel = `user_uid: ${this.userUid} | webinar_title: ${this.webinar.title} | webinar_category: ${this.webinar.webinar_category} | webinar_type: ${webinarType} | webinar_payment_status: ${webinarPaid} | user_register_status: ${userRegisterStatus} | question: ${msg} | device_category: web`;
    Alodokter.sendEventGA("watch webinar live", "webinar_live_qna", eventLabel);
    VideoPlayerAnalytics.vdQnaSubmit(this.webinar, msg);
  }

  _handleListenerPlayer(e, data){
    /** data -> pause, play, autoplay, ended */
    if(this.webinar.broadcast_status == "live"){
      //jika webinar live
      if(data == "play" || data == "autoplay"){
        if(this.trackingVdStartGA4){
          VideoPlayerAnalytics.vdStart(this.webinar, "webinar", "webinar_live");
          this.trackingVdStartGA4 = false;
        }
        this.shadowRoot.querySelector("#webinarSocket").send("session_log", {uid: this.userUid, type: 'active', room_id: this.webinar.id, platform: "dweb"})
      } else if(data == "ended") {
        VideoPlayerAnalytics.vdFinished(this.webinar, "webinar", "webinar_live");
      } else if(data == "error"){
        this.isVideoError = true;
      } else {
        this.shadowRoot.querySelector("#webinarSocket").send("session_log", {uid: this.userUid, type: 'deactive', room_id: this.webinar.id, platform: "dweb"})
      }
    }

    // GA
    if(data == "play" && this.webinar.broadcast_status == "finished") {
      //send ga play or start video recording
      this._sendGARecordingStart();
      if(this.trackingVdStartGA4) {
        VideoPlayerAnalytics.vdStart(this.webinar, "webinar", "webinar_recording");
        this.trackingVdStartGA4 = false;
      }
    } else if(data == "play" && this.webinar.broadcast_status == "live"){
      //send ga play or start video live
      this.sendGALiveStart();
    } else if(data == "ended" && this.webinar.broadcast_status == "finished"){
      // video recording finished
      this.sendGARecordingFinished();
      VideoPlayerAnalytics.vdFinished(this.webinar, "webinar", "webinar_recording");
    }
  }

  _sendGARecordingStart(){
    const webinar = this.webinar;
    const webinarType = webinar.type == "single" ? "webinar" : "event";
    const webinarPaymentStatus = webinar.is_paid_webinar ? "paid" : "free"
    const userRegisterStatus = webinar.is_registered ? "registered" : "not_registered";
    const channel = webinar.channel ? webinar.channel.type : "";
    const eventLabel = `user_uid: ${this.userUid} | webinar_title: ${webinar.title} | webinar_category: ${webinar.webinar_category} | webinar_type: ${webinarType} | webinar_payment_status: ${webinarPaymentStatus} | user_register_status: ${userRegisterStatus} | device_category: web | channel_type: ${channel}`
    Alodokter.sendEventGA("watch webinar recording", "webinar_recording_start", eventLabel);
  }

  sendGARecordingFinished(){
    const webinar = this.webinar;
    const webinarType = webinar.type == "single" ? "webinar" : "event";
    const webinarPaymentStatus = webinar.is_paid_webinar ? "paid" : "free"
    const userRegisterStatus = webinar.is_registered ? "registered" : "not_registered";
    const channel = webinar.channel ? webinar.channel.type : "";
    const eventLabel = `user_uid: ${this.userUid} | webinar_title: ${webinar.title} | webinar_category: ${webinar.webinar_category} | webinar_type: ${webinarType} | webinar_payment_status: ${webinarPaymentStatus} | user_register_status: ${userRegisterStatus} | device_category: web | channel_type: ${channel}`
    Alodokter.sendEventGA("watch webinar recording", "webinar_recording_finish", eventLabel);
  }

  sendGALiveFinished(){
    const webinar = this.webinar;
    const webinarType = webinar.type == "single" ? "webinar" : "event";
    const webinarPaymentStatus = webinar.is_paid_webinar ? "paid" : "free"
    const channel = webinar.channel ? webinar.channel.type : "";
    const eventLabel = `user_uid: ${this.userUid} | webinar_title: ${webinar.title} | webinar_category: ${webinar.webinar_category} | webinar_type: ${webinarType} | webinar_payment_status: ${webinarPaymentStatus} | device_category: web | channel_type: ${channel}`
    Alodokter.sendEventGA("watch webinar live", "webinar_live_finish", eventLabel);
  }
  
  sendGALiveStart(){
    const webinar = this.webinar;
    const webinarType = webinar.type == "single" ? "webinar" : "event";
    const webinarPaymentStatus = webinar.is_paid_webinar ? "paid" : "free"
    const channel = webinar.channel ? webinar.channel.type : "";
    const eventLabel = `user_uid: ${this.userUid} | webinar_title: ${webinar.title} | webinar_category: ${webinar.webinar_category} | webinar_type: ${webinarType} | webinar_payment_status: ${webinarPaymentStatus} | device_category: web | channel_type: ${channel}`
    Alodokter.sendEventGA("watch webinar live", "webinar_live_start", eventLabel);
  }

  _checkIsShowChatBox() {
    const isLive = this.webinar.broadcast_status === "live"
    const isQnAEnabled = this.webinar.is_question_enabled === true
    if (isLive && isQnAEnabled && this.isLogin && this.webinar.is_paid_webinar && this.webinar.is_registered) this.isShowQnABox = true
    if (isLive && isQnAEnabled && this.isLogin && !this.webinar.is_paid_webinar) this.isShowQnABox = true
  }

  _onNavigateSkp(){
    this.sendGAStartSkpPostTest();
    window.location = `/skp/${this.webinar.skp_id}`;
  }

  _onNavigateCertificate(){
    this.sendGAViewCertificate();
    window.location = `/certificate/${this.webinar.certificate_id}`;
  }

  getTrackingUserUid() {
    return this.userUid && this.isLogin ? `user_uid: ${this.userUid} | ` : "";
  }

  sendGaWebinarDetailPageView(){
    const webinar = this.webinar;
    const userUid = this.getTrackingUserUid();
    const webinarStatus = this._webinarEventStatus(webinar);
    const sourceUrl = window.location.href;
    const webinarPaymentStatus = webinar.is_paid_webinar ? "paid" : "free"
    const userRegisterStatus = this.webinar.is_registered ? "registered" : "not_registered";
    const eventLabel = `${userUid}webinar_title: ${webinar.title} | webinar_status: ${webinarStatus} | webinar_category: ${webinar.webinar_category} | webinar_payment_status: ${webinarPaymentStatus} | user_register_status: ${userRegisterStatus} | device_category: desktop | source_url: ${sourceUrl}`
    Alodokter.sendEventGA("webinar detail page", "webinar_detail_viewed", eventLabel);
  }

  sendGA4WebinarViewItem() {
    WebinarAnalytics.viewItem(this.webinar);
  }

  sendWebinarFreeRegisterClicked() {
    const webinar = this.webinar;
    const webinarType = webinar.type == "single" ? "webinar" : "event";
    const userUid = this.getTrackingUserUid();
    const webinarStatus = this._webinarEventStatus(webinar);
    const eventLabel = `${userUid}webinar_title: ${webinar.title} | webinar_status: ${webinarStatus} | webinar_type: ${webinarType} | webinar_category: ${webinar.webinar_category} | webinar_payment_status: free | device_category: desktop`
    Alodokter.sendEventGA("webinar detail page", "webinar_register_free_clicked", eventLabel);
  }

  sendWebinarPaidRegisterClicked() {
    const webinar = this.webinar;
    const webinarType = webinar.type == "single" ? "webinar" : "event";
    const userUid = this.getTrackingUserUid();
    const webinarStatus = this._webinarEventStatus(webinar);
    const eventLabel = `${userUid}webinar_title: ${webinar.title} | webinar_status: ${webinarStatus} | webinar_type: ${webinarType} | webinar_category: ${webinar.webinar_category} | webinar_payment_status: paid | device_category: desktop`
    Alodokter.sendEventGA("webinar detail page", "webinar_register_paid_clicked", eventLabel);
  }

  sendGA4WebinarAddToCart() {
    WebinarAnalytics.addToCart(this.webinar, 'webinar_detail');
  }

  sendGAStartSkpPostTest() {
    const webinar = this.webinar;
    const userUid = this.getTrackingUserUid();
    const webinarPaymentStatus = webinar.is_paid_webinar ? "paid" : "free"
    const sourceUrl = window.location.href;
    const eventLabel = `${userUid}webinar_title: ${webinar.title} | webinar_category: ${webinar.webinar_category} | webinar_payment_status: ${webinarPaymentStatus} | device_category: desktop | source_url: ${sourceUrl}`
    Alodokter.sendEventGA("webinar detail page", "webinar_start_post_test", eventLabel);
  }

  sendGAViewCertificate() {
    const webinar = this.webinar;
    const userUid = this.getTrackingUserUid();
    const webinarPaymentStatus = webinar.is_paid_webinar ? "paid" : "free"
    const sourceUrl = window.location.href;
    const eventLabel = `${userUid}webinar_title: ${webinar.title} | webinar_category: ${webinar.webinar_category} | webinar_payment_status: ${webinarPaymentStatus} | device_category: desktop | source_url: ${sourceUrl}`
    Alodokter.sendEventGA("webinar detail page", "webinar_get_certificate", eventLabel);
  }

  _handleSocketDisconnection() {
    this.socketConnect = false;
  }

  _handleSocketConnect(){
    this.socketConnect = true;
    this.shadowRoot.querySelector("#webinarSocket").send("session_log", {uid: this.userUid, type: 'active', room_id: this.webinar.id, platform: "dweb"})
  }

  _handleTrackingRecording(e, data) {
    VideoPlayerAnalytics.vdProgress(this.webinar, "webinar", "webinar_recording", data);
  }
  
  _handleTrackingLive(e, data) {
    VideoPlayerAnalytics.vdProgressLive(this.webinar, data);
  }
}

customElements.define("webinar-show", WebinarShow);
